import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];
        if (!sessionId) {
          navigate('/login', { replace: true });
          return;
        }

        const res = await api.get(`/auth/session?session_id=${sessionId}`);
        setUser(res.data);
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        navigate('/dashboard', { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error('Auth callback error:', err);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen items-center justify-center bg-[#F7F7F7]" data-testid="auth-callback">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-2 border-black border-t-[#FF5A00] animate-spin" />
        <p className="mt-4 font-mono text-sm uppercase tracking-wider text-[#5E5E5E]">
          Authenticating...
        </p>
      </div>
    </div>
  );
}
